
import { SistemaMixin } from "@/modules/Application";
import ModalNovidades from "@/modules/Dashboard/components/ModalNovidades.vue";

export default {
  name: "app-novidades-historico",
  mixins: [SistemaMixin],
  components: {
    ModalNovidades,
  },
  data() {
    return {
      loading: false,
      erro: "",
      pacotes: [],
      pacoteSelecionado: null,
    };
  },
  mounted() {
    this.$store.dispatch("setLoading", false);
    this.carregar();
  },
  methods: {
    async carregar() {
      this.loading = true;
      this.erro = "";
      try {
        const { data } = await this.$http.post("/novidades");
        this.pacotes = data.data || data || [];
      } catch (error) {
        this.erro =
          error?.response?.data?.msg ||
          error?.response?.data?.message ||
          "Não foi possível carregar as novidades. Tente novamente.";
      } finally {
        this.loading = false;
      }
    },

    verDetalhes(pacote) {
      this.pacoteSelecionado = pacote;
      this.$nextTick(() => {
        this.$bvModal.show("modal-novidades-historico");
      });
    },

    formatDate(date) {
      if (!date) return "";
      return this.$moment(date).format("DD/MM/YYYY");
    },
  },
};
